'use strict';

export default function getBookingIdentifier() {
  const space_id = window.localStorage.getItem('booking-space-id') || '';
  const date = window.localStorage.getItem('widget-date') || '';
  const start = window.localStorage.getItem('widget-start') || '';
  const end = window.localStorage.getItem('widget-end') || '';
  return [space_id, date, start, end].join(';');
}
